import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { formatTimezoneThenStraight } from "../../common-data/Converts";
import PaginationModified from "../../../data/PaginationModified";

const CartHistoryMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  setModValues,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info">
                <div className="log-card-top">
                  <h3 className="lead-name name-checkbox">
                    {row?.name || "NA"}
                  </h3>

                  <span
                    className={`lead-type ${row?.status}`}
                    style={{
                      background:
                        row?.status === "completed" ? "#E2EFD5" : "#F3DADA",
                      color:
                        row?.status === "completed" ? "#379C00" : "#D90000",
                    }}
                  >
                    {row?.status || "NA"}
                  </span>
                </div>

                <div className="card-other-info">
                  <span className="value semi-bold">{row?.mobile || ""}</span>

                  <span className="value semi-bold">
                    {row?.gym_name || "NA"}
                  </span>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="heade-info">
                          <span className="title">plan name</span>
                          <span className="value">
                            {row?.plan_name?.replace(/_/g, " ") || "NA"}
                          </span>
                        </div>
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px">
                          <div className="label-value">
                            <span className="label">agent</span>
                            <span className="value">
                              {row?.agent_name || "NA"}
                              <br />
                              <small
                                style={{
                                  textTransform: "lowercase",
                                }}
                              >
                                {row?.agent_mobile || ""}
                                <br />
                                {row?.agent_email || ""}
                              </small>
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">date added</span>
                            <span className="value">
                              {row?.date_added
                                ? formatTimezoneThenStraight(row.date_added)
                                : "-"}
                            </span>
                          </div>
                        </div>

                        <div className="all-btns lead-btn-axceed">
                          <div className="lead-log-box">
                            <button
                              className="lead-log view-lead"
                              onClick={() => {
                                setModValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  cardName: "plan_details",
                                  rowData: [row?.req_body] || [],
                                }));
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-view-list"
                                viewBox="0 0 16 16"
                              >
                                <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
                              </svg>
                            </button>

                            <span className="btn-label">plan detail</span>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
        />
      </div>
    </div>
  );
};

export default CartHistoryMobile;
